import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PersonPage from './components/PersonPage';
import LoginPage from './components/LoginPage';

function ProtectedRoute({ person }: { person: 'tim' | 'diya' }) {
  const { userType, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4 animate-pulse">💕</div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If not authenticated or trying to access wrong page, redirect to login
  if (!userType || userType !== person) {
    return <Navigate to="/" replace />;
  }

  return <PersonPage person={person} />;
}

function LoginRoute() {
  const { userType, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4 animate-pulse">💕</div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If already authenticated, redirect to their page
  if (userType) {
    return <Navigate to={`/${userType}`} replace />;
  }

  return <LoginPage />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginRoute />} />
          <Route path="/tim" element={<ProtectedRoute person="tim" />} />
          <Route path="/diya" element={<ProtectedRoute person="diya" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;